const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();
const SingleStopInfo = require('../components/single-stop-info');

module.exports = {
  name: 'row',
  props: {
    stop: {
      type: Object,
      required: true,
    },
    stopInfo: {
      type: Array,
      required: false,
    },
    sortedTrips: {
      type: Array,
      required: true,
    },
    // all trips on panel w/ id, earliest depararture time, and highestSequence
    allTrips: {
      type: Object,
      required: true,
    },
    routeData: {
      type: Array,
      required: true,
    },
  },

  computed: {
    //creates object whos keys are stop ids to hold all stop info
    associativeStopInfo() {
      const stopsInfoObj = {};
      for (let x = 0; x < this.stopInfo.length; x++) {
        // console.log(this.stopInfo[x]);
        stopsInfoObj[this.stopInfo[x].stop_id] = this.stopInfo[x];
      }
      // console.log(stopsInfoObj);
      return stopsInfoObj;
    },
  },

  methods: {
    // finds the correct stop time based off trip and id, works similar to x,y coordinates
    findStopTime(stop, trip, rawData) {
      for (let x = 0; x < rawData.length; x++) {
        if (rawData[x].trip_id == trip.id && rawData[x].stop_id == stop.id) {
          let time;
          // let debug;
          // check if the stop sequence of this stop is the highest on trip
          if ( rawData[x].field_stop_sequence == trip.highestSequence) {
            time = Date.parse(rawData[x].field_arrival_time);
            // debug = 'a';
          } else {
            // else use departure
            time = Date.parse(rawData[x].field_departure_time);
            // debug = 'd';
          }

          // //////////////
          // SPECIAL CASE!
          // //////////////
          if (trip.id == 'trip_41i_0612' && stop.id == 'stop_ports014') {
            time = Date.parse(rawData[x].field_arrival_time);
            // debug = 'a';
          }

          // //////////////
          // SPECIAL CASE!
          // //////////////
          // Display "--" if stop is drop off only.
          // if (trip.id == 'trip_43i_0645_jan21' && stop.id == 'stop_ntn9013') {
          if ( this.findPickupType(stop.id, trip.id, rawData) == 1 ) {
            // console.log('Special rule: Stop is drop off only.');
            return;
          }

          // hours will be basic hour, no leading zero - uses 12hr clock
          const h = time.getHours() > 12 ? time.getHours() - 12 : time.getHours();
          // add the leading zero to minutes if under 10
          const m = time.getMinutes() >= 10 ? time.getMinutes() : `0${time.getMinutes()}`;
          // using a & p instead of am/pm
          const a = time.getHours() < 12 ? 'a' : 'p';

          return `${h}:${m}${a}`;
        }
      }
    },

    // grabs the stop sequence for the for the datum
    // used for debugging to make sure things are sorted correctly
    // can double check the real sequence of items against this value
    findStopSeq(stop, trip, rawData) {
      for (let x = 0; x < rawData.length; x++) {
        if (rawData[x].trip_id == trip && rawData[x].stop_id == stop) {
          return rawData[x].field_stop_sequence;
        }
      }
    },

    findPickupType(stop, trip, rawData) {
      for (let x = 0; x < rawData.length; x++) {
        if (rawData[x].trip_id == trip && rawData[x].stop_id == stop) {
          return rawData[x].pickup_type;
        }
      }
    },
  },

  mounted: function() {
    // console.log(this.routeData);
    // console.log(this.stop)
  },

  render() {
    return(
      <div class="tr" ref="tablerow" data-timepoint={this.stop.timepoint} data-pickup-type={this.stop.pickupType}>
        {/*  then columns */}
        {/* first column in every row is stop name*/}
        <div class="td stop-name">
          <span class="stop-name__title" data-stop-id={this.stop.id}>{entities.decode(this.stop.alias).replace("\\'", "'")}</span>
          {/* if theres any stop info, add the component */}
          {this.associativeStopInfo.hasOwnProperty(this.stop.id) &&
            <SingleStopInfo singleStopInfo={this.associativeStopInfo[this.stop.id]} />
          }
        </div>

        <div class="stop-times-row">
          <div ref="stop_times" class="stop-times-row__inner">
          {this.sortedTrips.map(trip =>
            // this.findPickupType(this.stop.id, this.allTrips[trip[0]].id, this.routeData) != 1 &&
              <div
                class="td"
                data-stop-id={this.stop.id}
                data-stop-seq={this.findStopSeq(this.stop.id, this.allTrips[trip[0]].id, this.routeData)}
                data-trip-id={this.allTrips[trip[0]].id}
                data-pickup-type={this.findPickupType(this.stop.id, this.allTrips[trip[0]].id, this.routeData)}
                >
                  <span class="stoptime">{this.findStopTime(this.stop, this.allTrips[trip[0]], this.routeData)}</span>
              </div>
          )}
          </div>
        </div>
      </div>
    );
  },
};
